import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { MapPin } from 'lucide-react';
import { Monitor, Smartphone, Palette, Megaphone, Code2, Cloud } from 'lucide-react';
const services = [{
  icon: <Monitor className="w-8 h-8" data-id="element-224" />,
  title: 'Website Development',
  description: 'Custom, high-performance websites built with modern technologies to convert visitors into customers.',
  locationInfo: 'Serving businesses across Lagos, Abuja, London, and Manchester with responsive, SEO-optimized websites tailored for the UK and Nigerian markets.',
  colSpan: 'md:col-span-2',
  image: 'https://images.unsplash.com/photo-1547658719-da2b51169166?q=80&w=1200&auto=format&fit=crop'
}, {
  icon: <Smartphone className="w-8 h-8" data-id="element-225" />,
  title: 'Mobile Applications',
  description: 'Native and cross-platform mobile apps that deliver seamless user experiences on iOS and Android.',
  locationInfo: 'Building mobile solutions for startups and enterprises in Nigeria and the UK, with expertise in fintech, e-commerce, and on-demand service apps.',
  colSpan: 'md:col-span-1',
  image: 'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?q=80&w=1200&auto=format&fit=crop'
}, {
  icon: <Palette className="w-8 h-8" data-id="element-226" />,
  title: 'UI/UX Design',
  description: 'User-centric design solutions that combine aesthetics with functionality for intuitive digital products.',
  locationInfo: 'Creating culturally relevant designs for Nigerian and British audiences, ensuring optimal user engagement across both markets.',
  colSpan: 'md:col-span-1',
  image: 'https://images.unsplash.com/photo-1561070791-2526d30994b5?q=80&w=1200&auto=format&fit=crop'
}, {
  icon: <Megaphone className="w-8 h-8" data-id="element-227" />,
  title: 'Digital Marketing',
  description: 'Data-driven strategies to increase your online visibility, traffic, and brand engagement.',
  locationInfo: 'Specialized SEO and digital marketing campaigns targeting customers in Nigeria, UK, and globally with localized content strategies.',
  colSpan: 'md:col-span-2',
  image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?q=80&w=1200&auto=format&fit=crop'
}, {
  icon: <Code2 className="w-8 h-8" data-id="element-228" />,
  title: 'Software Solutions',
  description: 'Scalable enterprise software tailored to streamline your business operations and workflows.',
  locationInfo: 'Developing custom software for businesses in Lagos, Abuja, London, and beyond with 24/7 support across time zones.',
  colSpan: 'md:col-span-1',
  image: 'https://images.unsplash.com/photo-1555066931-4365d14bab8c?q=80&w=1200&auto=format&fit=crop'
}, {
  icon: <Cloud className="w-8 h-8" data-id="element-229" />,
  title: 'Cloud Services',
  description: 'Secure and reliable cloud infrastructure setup, management, and migration services.',
  locationInfo: 'Providing cloud solutions with data centers optimized for both UK and Nigerian businesses, ensuring compliance with local regulations.',
  colSpan: 'md:col-span-2',
  image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?q=80&w=1200&auto=format&fit=crop'
}];
export function Services() {
  return <Section id="services" className="bg-[#0B1426] relative" data-id="element-230">
      <div className="absolute inset-0 bg-grid-pattern-small opacity-[0.03] pointer-events-none" data-id="element-231" />

      <div className="text-center max-w-3xl mx-auto mb-16 relative z-10" data-id="element-232">
        <motion.span initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-[#d8a43e] font-mono text-sm tracking-widest uppercase bg-[#d8a43e]/10 px-3 py-1 rounded border border-[#d8a43e]/20" data-id="element-233">
          // Our Expertise
        </motion.span>
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="mt-6 text-4xl md:text-5xl font-bold text-white" data-id="element-234">
          Comprehensive{' '}
          <span className="text-[#d8a43e]" data-id="element-235">Digital Solutions</span>
        </motion.h2>
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="mt-6 text-gray-400 text-lg" data-id="element-236">
          We combine creativity with technical excellence to deliver results
          that matter. Proudly serving clients in Nigeria and the United
          Kingdom.
        </motion.p>
      </div>

      <div className="grid md:grid-cols-3 gap-6 relative z-10" data-id="element-237">
        {services.map((service, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} whileHover={{
        y: -5,
        scale: 1.01
      }} className={`relative p-8 rounded-2xl border border-white/5 hover:border-[#d8a43e]/30 transition-all duration-300 group overflow-hidden ${service.colSpan || ''}`} data-id="element-238">
            {/* Background Image */}
            <div className="absolute inset-0 z-0" data-id="element-239">
              <img src={service.image} alt="" className="w-full h-full object-cover opacity-[0.07] group-hover:opacity-[0.15] transition-opacity duration-700 group-hover:scale-105 transform" data-id="element-240" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0B1426] via-[#0B1426]/95 to-[#0B1426]/80" data-id="element-241" />
            </div>

            <div className="relative z-10" data-id="element-242">
              <div className="flex items-start justify-between mb-6" data-id="element-243">
                <div className="w-14 h-14 rounded-xl bg-[#d8a43e]/10 flex items-center justify-center text-[#d8a43e] group-hover:bg-[#d8a43e] group-hover:text-black transition-colors duration-300" data-id="element-244">
                  {service.icon}
                </div>
                <span className="font-mono text-xs text-gray-600 group-hover:text-[#d8a43e] transition-colors" data-id="element-245">
                  0{index + 1}
                </span>
              </div>

              <h3 className="text-xl font-bold text-white mb-3 group-hover:text-[#d8a43e] transition-colors" data-id="element-246">
                {service.title}
              </h3>
              <p className="text-gray-400 leading-relaxed group-hover:text-gray-300 mb-4" data-id="element-247">
                {service.description}
              </p>

              {/* Location-optimized paragraph */}
              <div className="flex items-start gap-2 pt-4 border-t border-white/5" data-id="element-248">
                <MapPin className="w-4 h-4 text-[#d8a43e] shrink-0 mt-0.5" data-id="element-249" />
                <p className="text-xs text-gray-500 leading-relaxed" data-id="element-250">
                  {service.locationInfo}
                </p>
              </div>
            </div>

            {/* Tech Decoration */}
            <div className="absolute bottom-4 right-4 w-2 h-2 bg-[#d8a43e] rounded-full opacity-0 group-hover:opacity-100 transition-opacity z-10" data-id="element-251" />
          </motion.div>)}
      </div>
    </Section>;
}